import React from "react";
import Navbar from "@/components/common/Navbar";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button, buttonVariants } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { useState, useEffect } from "react";
import { sendEmail } from "@/services/contact";
import { fetchUserAttributes } from "aws-amplify/auth";


const formSchema = z.object({
  email: z.string().email().min(1, { message: "Email is a required field" }),
  subject: z.string().min(1, { message: "Subject is a required field" }),
  description: z
    .string()
    .min(1, { message: "Description is a required field" }),
  priority: z.enum(["high", "normal", "low", ""]).optional(),
});

const priorityOptions = ["high", "normal", "low"];

const Support = () => {
  const email = "";
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchEmail = async () => {
      try {
        const attributes = await fetchUserAttributes();
        form.reset({ ...form.getValues(), email: attributes.email || "" });
      } catch (err) {
        console.error("Failed to fetch user email:", err);
      }
    };
  
    fetchEmail();
  }, []);
  
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: email,
      subject: "",
      description: "",
      priority: "normal",
    },
  });

  async function onSubmit(values) {
    setLoading(true);
    try {
      // const response = await axios.post('/api/mail', values);
      await sendEmail(values).then(
        (response) => {
          toast(response.message);
          form.reset();
        },
        (error) => {
          toast("Something went wrong! Please check your internet connection.");
        }
      );
    } catch (error) {
      toast("Something went wrong! Please check your internet connection.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="h-full flex-1 flex-col md:flex">
      <Navbar />
      <div className="p-8">
        <div className="w-1/2 mt-8 ">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <div className="grid grid-cols-1 gap-4 w-full">
                <div className="col-span-1 md:col-span-2">
                  <FormField
                    control={form.control}
                    name="email"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Email Address</FormLabel>
                        <FormControl>
                          <Input {...field} disabled />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
                <div className="col-span-1 md:col-span-2">
                  <FormField
                    control={form.control}
                    name="subject"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Subject</FormLabel>
                        <FormControl>
                          <Input type="text" {...field} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
                <div className="col-span-1 md:col-span-2">
                  <FormField
                    control={form.control}
                    name="priority"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Priority</FormLabel>
                        <FormControl>
                          <select
                            {...field}
                            className="w-full p-2 border border-gray-300 rounded"
                          >
                            {priorityOptions.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
                <div className="col-span-1 md:col-span-2">
                  <FormField
                    control={form.control}
                    name="description"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Description</FormLabel>
                        <FormControl>
                          <Textarea rows={10} {...field} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
              </div>
              <Button
                type="submit"
                disabled={loading}
                className={buttonVariants({
                  variant: "default",
                  className: "px-12 py-6 text-xl rounded-xl my-4",
                })}
              >
                Submit
              </Button>
            </form>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Support;